import { ListSelectedFilter } from "../core/components/Filter/services/types";
import { ForceListDispatchActionMode } from "../list/services/types";

export const prepareActionFilterItems = (
	newActionItems: ListSelectedFilter[],
	previousListStateItems?: ListSelectedFilter[],
	dispatchMode?: ForceListDispatchActionMode
) => {
	if (dispatchMode === ForceListDispatchActionMode.OVERRIDE_COMPLETELY) return newActionItems;

	const newActionItemsMap: Map<string, ListSelectedFilter> = newActionItems.reduce((actionsMap, currentAction) => {
		return actionsMap.set(currentAction.filterId, currentAction);
	}, new Map());
	const filteredPreviousListStateItems =
		previousListStateItems?.filter((previousStateItem) => !newActionItemsMap.has(previousStateItem.filterId)) ?? [];

	if (dispatchMode === ForceListDispatchActionMode.REMOVE) {
		return filteredPreviousListStateItems;
	}

	return [...filteredPreviousListStateItems, ...newActionItems];
};

export const prepareActionColumnItems = (
	selectedColumns: string[],
	columnsToUpdate: string[],
	forceDispatchAction: ForceListDispatchActionMode
) => {
	if (forceDispatchAction === ForceListDispatchActionMode.OVERRIDE_COMPLETELY) {
		return columnsToUpdate;
	}

	const filteredPreviousColumns = selectedColumns.filter((column) => !columnsToUpdate.includes(column));

	if (forceDispatchAction === ForceListDispatchActionMode.REMOVE) {
		return filteredPreviousColumns;
	}

	return [...filteredPreviousColumns, ...columnsToUpdate];
};
